export const LightBulbIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M12.9166 13.6014C12.9166 12.5437 13.516 11.6044 14.2326 10.8371C15.2247 9.77471 15.8333 8.3392 15.8333 6.75927C15.8333 3.48647 13.2216 0.833344 9.99996 0.833344C6.7783 0.833344 4.16663 3.48647 4.16663 6.75927C4.16663 8.3392 4.77526 9.77471 5.76733 10.8371C6.4839 11.6044 7.08329 12.5437 7.08329 13.6014V14.1667H8.83329H10.875H12.9166V13.6014Z" />
        <path d="M7.5 19.1667H12.5" />
        <path d="M6.66663 16.6667H13.3333" />
      </g>
    </svg>
  );
};
